import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseInterface } from '../interface/auth';

@Injectable({
  providedIn: 'root'
})

/**
 * Common Service
 */
export class CommonService {
  private updateSidebar: any;
  public updateSidebarObservable!: Observable<boolean>;

  /**
   * constructor
   */
  constructor(
    private httpClient: HttpClient,
  ) {
    this.updateSidebar = new BehaviorSubject(false);
    this.updateSidebarObservable = this.updateSidebar.asObservable();
  }

  /**
   * updates the Sidebar
   * @param{boolean}updateStatus
   */
  public updateSidebarStatus(updateStatus: boolean): void {
    this.updateSidebar.next(updateStatus);
  }

  /**
 * get countries
 * @return{ApiResponseInterface}Observable
 */
  getCountries(): Observable<ApiResponseInterface> {
    return this.httpClient.get<ApiResponseInterface>(`${environment.API_BASE_URL}countries`);
  }

  /**
   * get states
   * @param{number}countryId
   * @return{ApiResponseInterface}Observable
   */
  getStates(countryId: string): Observable<ApiResponseInterface> {
    console.log();

    return this.httpClient.get<ApiResponseInterface>(`${environment.API_BASE_URL}states?country_id=${countryId}`);
  }

  /**
   * get states
   * @param{number}stateId
   * @return{ApiResponseInterface}Observable
   */
  getCities(stateId: number): Observable<ApiResponseInterface> {
    return this.httpClient.get<ApiResponseInterface>(`${environment.API_BASE_URL}cities?state_id=${stateId}`);
  }

}
